module.exports = __webpack_public_path__ + "static/media/res11.1b3931ec.PNG";